module.exports = __webpack_public_path__ + "static/media/tire-rotation.9481fb60.svg";